/*
 * @Author: Hyman Choi
 * @Date: 2021-01-14 10:37:59
 * @LastEditTime: 2022-01-14 17:51:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\router\Modules\cloudStorage.js
 */
import Layout from "@/layout";

const cloudStorageRouter = {
	path: "/cloudStorage",
	component: Layout,
	redirect: "/cloudStorage/myFiles",
	name: "cloudStorage",
	meta: {
		roles: ["超级管理员",'系统管理员'],
		title: "cloudStorage",
		icon: "cloudStorage",
	},
	children: [
		{
			path: "cloudStorage",
			name: "cloudStorage",
			component: () => import("@/views/oldCloudStorage/index"),
			meta: {
				roles: ["超级管理员",'系统管理员','Super Admin'],
				title: "cloudStorage",
			},
		},
		// {
		// 	path: "myFiles",
		// 	name: "myFiles",
		// 	component: () => import("@/views/cloudStorage/myFiles/index"),
		// 	meta: {
		// 		roles: ["超级管理员", "普通用户"],
		// 		title: "myFiles",
		// 	},
		// },
		// {
		// 	path: "myReport",
		// 	name: "myReport",
		// 	component: () => import("@/views/cloudStorage/myReport/index"),
		// 	meta: {
		// 		roles: ["超级管理员", "普通用户"],
		// 		title: "myReport",
		// 	},
		// },
		// {
		// 	path: "reportTemplate",
		// 	name: "reportTemplate",
		// 	component: () => import("@/views/cloudStorage/reportTemplate/index"),
		// 	meta: {
		// 		roles: ["超级管理员", "普通用户"],
		// 		title: "reportTemplate",
		// 	},
		// },
		// {
		// 	path: "reportThesaurus",
		// 	name: "reportThesaurus",
		// 	component: () => import("@/views/cloudStorage/reportThesaurus/index"),
		// 	meta: {
		// 		roles: ["超级管理员", "普通用户"],
		// 		title: "reportThesaurus",
		// 	},
		// },
	],
};

export default cloudStorageRouter;
